import React from "react";

import styles from "./About.module.css";
import AboutUsImage from "./aboutus.jpg";

import { Button } from "@chakra-ui/react";
import { Link } from "react-router-dom";

export const About = () => {
  return (
    <section className={styles.container} id="about">
      <div className={styles.textwithlines}>
        <div className={styles.line}></div>
        <h2 className={styles.title}>About Adarsh industries</h2>
        <div className={styles.line}></div>
      </div>
      <div className={styles.content}>
        <div>
          <p>
            <b>Adarsh Industries</b> is a leading cattle feed manufacturer with
            a rich history dating back to June 1990. For nearly <b>35 years</b>,
            we have been dedicated to providing the highest quality cattle feed
            products to farmers and their livestock. Our commitment to
            excellence has made us a trusted name in the industry.
          </p>
          <p>
            We understand that healthy cattle are essential for the success of
            farmers. That's why we strive to create premium cattle feed
            solutions that not only nourish but also enhance the well-being of
            your animals. Our products are formulated with the utmost care,
            using only the finest ingredients to ensure optimal nutrition and
            growth.
          </p>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <Button padding={"0.3rem"} borderRadius={"1rem"}>
              <Link
                style={{
                  color: "black",
                  textDecoration: "none",
                }}
                to={"/about"}
              >
                Read More
              </Link>
            </Button>
          </div>
        </div>
        <img
          src={AboutUsImage}
          alt="Me sitting with a laptop"
          className={styles.aboutImage}
        />
        {/* <img
          src={getImageUrl("about/aboutImage.png")}
          alt="Me sitting with a laptop"
          className={styles.aboutImage}
        /> */}
        {/* <MyVideoComponent /> */}
        {/* <ul className={styles.aboutItems}>
          <li className={styles.aboutItem}>
            <div className={styles.aboutItemText}>
              <h2>Infrastructure</h2>
              <p>
                Our modern manufacturing facility stands at the forefront of
                innovation, boasting advanced technology-based, state-of-the-art
                production machinery. This sophisticated infrastructure enables
                us to uphold the highest standards of quality and efficiency in
                our manufacturing processes, ensuring precision and reliability
                in every aspect of production.
              </p>
            </div>
          </li>
          <li className={styles.aboutItem}>
            <div className={styles.aboutItemText}>
              <h2>Company</h2>
              <p>
                Introducing Adarsh industries, a meticulously crafted,
                nutritionally balanced feed for cattle. Developed in
                collaboration with experienced nutritionists, our aim is to
                empower cattle farmers with a superior feeding solution,
                enhancing the well-being of their livestock and fostering
                agricultural prosperity.
              </p>
            </div>
          </li>
        </ul> */}
      </div>
    </section>
  );
};
